import { REGULATION_DISCLAIMER_TEXT } from '@config/constants';
import { Text } from '../../Text/Text';

export const RegulationDisclaimer = () => (
  <Text className="text-abyss" variant="md">
    {REGULATION_DISCLAIMER_TEXT}
  </Text>
);
